import { Unit, TaxStatus, Frequency, MatchType } from './AccountWorklow.meta';

export const BACKEND_KEY = 'Accounts';

export const BASE_ACCOUNT = {
  AccountEarmark: [],
  AccountId: null,
  frontEndId: null,
  Balances: {
    Unit: Unit.Dollar,
  },
  Contributions: [
    {
      PersonalTaxStatus: TaxStatus.Traditional,
      PersonalUnit: Unit.Dollar,
      PersonalFrequency: Frequency.Monthly,
      PersonalMaximize: false,
      EmployerTaxStatus: TaxStatus.Traditional,
      EmployerMatchType: MatchType.NotSure,
    },
  ],
};
export const NO_CONTRIBUTION = 0;
export const DOLLAR_CONTRIBUTION = 1;
export const PERCENTAGE_CONTRIBUTION = 2;
